
import SettingsMetaData from "../../../../../Components/Hooks/useSettingsMetaData";

const Desigination = () => {
  return (
    <SettingsMetaData propertyName={"Desigination_Customer"} viewPropertyName={"Desigination"} />
  );
};
export default Desigination;
